import React from 'react';
import { view } from 'react-easy-state';
import { rgba } from 'polished';

import Repo from './repo';
import { sortRepos } from '../helpers';
import main from '../stores';

export const CardWrapper = ({ children }) => (
  <div css={[tw`w-full sm:w-1/2 md:w-1/3 z-50`]}>
    <div
      css={[
        tw`m-2 rounded-lg overflow-hidden bg-white border-grey-lighter border-0`,
        {
          boxShadow: `0 0 2px 0 ${rgba('#000', 0.1)}, 0 5px 15px 0 ${rgba('#000', 0.0325)}`,
        }
      ]}
    >
      {children}
    </div>
  </div>
);

export default
@view
class Category extends React.Component {
  render() {
    const {
      category: {
        slug,
        title,
        repos,
        totalRepos
      },
    } = this.props;
    const { sortField } = main;

    const sorted = sortRepos({ repos, sortField });

    return (
      <CardWrapper>
        <div css={tw`px-4 pt-4`}>
          {/* eslint-disable-next-line */}
          <a href={`#${slug}`} id={slug} className="anchor" aria-hidden="true" />
          <span
            css={[tw`ml-3 font-bold text-sm text-brand border-brand border-2 rounded float-right`, {
              padding: '0.075em 0.2em',
            }]}
          >
            {totalRepos}
          </span>

          <h3
            css={[
              tw`font-black text-grey-darker text-2xl mb-2 tracking-tight`,
              { lineHeight: '.8em' },
            ]}
            // className="brand-dot"
          >
            {title}
          </h3>
        </div>

        <div css={tw`px-4`}>
          <ul css={tw`list-reset`}>
            {sorted.map(repo => (
              <Repo key={repo.slug} {...repo} />
            ))}
          </ul>
        </div>
      </CardWrapper>
    );
  }
}
